"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var CBOR = require("@wireapp/cbor");
var ClassUtil_1 = require("../util/ClassUtil");
var InputError_1 = require("../errors/InputError");
var KeyPair_1 = require("./KeyPair");
var PreKey = (function () {
    function PreKey() {
        this.key_id = -1;
        this.key_pair = new KeyPair_1.default();
        this.version = -1;
    }
    PreKey.new = function (pre_key_id) {
        return __awaiter(this, void 0, void 0, function () {
            var pk, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.validate_pre_key_id(pre_key_id);
                        pk = ClassUtil_1.default.new_instance(PreKey);
                        pk.version = 1;
                        pk.key_id = pre_key_id;
                        _a = pk;
                        return [4, KeyPair_1.default.new()];
                    case 1:
                        _a.key_pair = _b.sent();
                        return [2, pk];
                }
            });
        });
    };
    PreKey.validate_pre_key_id = function (pre_key_id) {
        if (pre_key_id === undefined) {
            throw new InputError_1.default.TypeError('PreKey ID is undefined.', InputError_1.default.CODE.CASE_404);
        }
        else if (typeof pre_key_id === 'string') {
            throw new InputError_1.default.TypeError("PreKey ID \"" + pre_key_id + "\" is a string.", InputError_1.default.CODE.CASE_403);
        }
        else if (pre_key_id % 1 !== 0) {
            throw new InputError_1.default.TypeError("PreKey ID \"" + pre_key_id + "\" is a floating-point number.", InputError_1.default.CODE.CASE_403);
        }
        else if (pre_key_id < 0 || pre_key_id > PreKey.MAX_PREKEY_ID) {
            var message = "PreKey ID (" + pre_key_id + ") must be between or equal to 0 and " + PreKey.MAX_PREKEY_ID + ".";
            throw new InputError_1.default.RangeError(message, InputError_1.default.CODE.CASE_400);
        }
    };
    PreKey.last_resort = function () {
        return PreKey.new(PreKey.MAX_PREKEY_ID);
    };
    PreKey.generate_prekeys = function (start, size) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validate_pre_key_id(start);
                        this.validate_pre_key_id(size);
                        if (size === 0) {
                            return [2, []];
                        }
                        return [4, Promise.all(new Array(size).fill(null).map(function (_, index) { return __awaiter(_this, void 0, void 0, function () {
                                var pk;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, PreKey.new((start + index) % PreKey.MAX_PREKEY_ID)];
                                        case 1:
                                            pk = _a.sent();
                                            return [2, pk];
                                    }
                                });
                            }); }))];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    PreKey.prototype.serialise = function () {
        var encoder = new CBOR.Encoder();
        this.encode(encoder);
        return encoder.get_buffer();
    };
    PreKey.deserialise = function (buf) {
        return PreKey.decode(new CBOR.Decoder(buf));
    };
    PreKey.prototype.encode = function (encoder) {
        encoder.object(3);
        encoder.u8(0);
        encoder.u8(this.version);
        encoder.u8(1);
        encoder.u16(this.key_id);
        encoder.u8(2);
        return this.key_pair.encode(encoder);
    };
    PreKey.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(PreKey);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    self.version = decoder.u8();
                    break;
                case 1:
                    self.key_id = decoder.u16();
                    break;
                case 2:
                    self.key_pair = KeyPair_1.default.decode(decoder);
                    break;
                default:
                    decoder.skip();
            }
        }
        return self;
    };
    PreKey.MAX_PREKEY_ID = 0xffff;
    return PreKey;
}());
exports.default = PreKey;
//# sourceMappingURL=PreKey.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/keys/PreKey.js
// module id = 63
// module chunks = 0 1